import LeasingSelectYear from "../Leasingselect";
import { LeasingRegional } from "../api/types";
import { useTranslation } from 'react-i18next';
import styles from "./styles.module.css";

interface Props {
    data?: LeasingRegional;
    isLoading: boolean;
    selectedYear: number | null;
    onYearChange: (year: number | null) => void;
}

export const LeasingByRegion = ({ data, isLoading, selectedYear, onYearChange }: Props) => {
    const { t, i18n } = useTranslation();
    if (isLoading) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loader}></div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>{t("Leasing of machinery by region")}</h2>
                <div className={styles.yearSelect}>
                    <LeasingSelectYear 
                        value={selectedYear}
                        onChange={onYearChange}
                    />
                </div>
            </div>
            <div className={styles.grid}>
                {data?.res?.map((region) => (
                    <div key={region.regionNameRu} className={styles.gridItem}>
                        <div className={styles.card}>
                            <h3 className={styles.regionName}>{region.regionNameRu}</h3>
                            <div className={styles.statItem}>
                                <span className={styles.label}>{t("Quantity")}</span>
                                <span className={styles.value}>{region.totalCount}</span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.label}>{t("Financing amount")}</span>
                                <span className={styles.value}>{region.totalFinancing} сом</span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.label}>{t("Average lease term")}</span>
                                <span className={styles.value}>{Number(region.avgLeaseTerm).toFixed(2)} {t("years")}</span>
                            </div>
                            <div className={styles.statItem}>
                                <span className={styles.label}>{t("Average lease term")}</span>
                                <span className={styles.value}>{Number(region.avgInterestRate).toFixed(2)}%</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}